import { z } from 'zod';

const attributeTransformations = ['lowercase', 'none', 'uppercase'] as const;

export type SiteSeparationAttributeTransformation =
  (typeof attributeTransformations)[number];

export const siteSeparationAttributeTransformationSchemaZ = z.enum(
  attributeTransformations,
);
